import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import JitsiSession from "./JitsiSession";
import LiveTranscriptPanel from "../HiralityMeetings/LiveTranscriptPanel";
import { SESSION_TYPES } from "./sessionTypes";
import { apiBaseUrl } from "../../../../services/config";

const API = apiBaseUrl;
const useQuery = () => new URLSearchParams(useLocation().search);

// Meeting type — lifted from MeetingRoom.jsx unchanged. LiveTranscriptPanel.jsx
// is already a fully self-contained dock (owns its own websocket/speech-
// recognition/badges and its own rail+drawer chrome), so it's reused as-is;
// this file's job is reading this type's own query params and wiring the
// shared JitsiSession wrapper with the "meeting" config + the /end-on-leave
// call MeetingRoom.jsx used to own.
export default function MeetingBody() {
  const query = useQuery();
  const navigate = useNavigate();
  const roomId       = query.get("roomId");
  const meetingId    = query.get("meetingId");
  const tokenFromURL = query.get("token");
  const displayName  = query.get("displayName") || "Guest";
  // Purely cosmetic label (see meetingTypes.js) — tunes the dock's copy,
  // never which SessionRoom body renders (that's the separate `type` param).
  const meetingType  = query.get("meetingType") || "meeting";
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (tokenFromURL) {
      sessionStorage.setItem("platform_token", tokenFromURL);
      localStorage.setItem("platform_token", tokenFromURL);
    }
    setReady(true);
  }, [tokenFromURL]);

  const handleLeave = async () => {
    if (meetingId) {
      try {
        const token = sessionStorage.getItem("platform_token") || localStorage.getItem("platform_token") || "";
        await axios.post(`${API}/hirality-meetings/${meetingId}/end`, {}, { headers: { Authorization: `Bearer ${token}` } });
      } catch (e) {
        console.warn("Could not finalize meeting:", e.message);
      }
    }
    navigate("/hirality-meeting-ended");
  };

  if (!ready || !roomId) {
    return (
      <div style={{ height: "100vh", width: "100vw", background: "#06101F", display: "flex",
        alignItems: "center", justifyContent: "center", color: "#7A93B4", fontFamily: "Outfit,sans-serif" }}>
        {roomId ? "Connecting…" : "Missing meeting room — this link looks invalid."}
      </div>
    );
  }

  const jitsi = SESSION_TYPES.meeting.jitsi;
  return (
    <>
      <JitsiSession
        roomName={roomId}
        displayName={displayName}
        scriptSrc={jitsi.scriptSrc}
        configOverwrite={jitsi.configOverwrite}
        interfaceConfigOverwrite={jitsi.interfaceConfigOverwrite}
        onLeave={handleLeave}
      />
      {meetingId && <LiveTranscriptPanel meetingId={meetingId} displayName={displayName} meetingType={meetingType} />}
    </>
  );
}
